// @flow

// import { init as clickyInit } from 'kodyl-js/client/clicky';

// import uuidV4 from 'kodyl-js/shared/uuid';
// import cookies from 'kodyl-js/client/cookies';

import { addTransport as addTracking } from 'kodyl-js/tracking';
// import trkClicky from 'kodyl-js/tracking/transport/clicky';
import trkGA from 'kodyl-js/tracking/transport/ga';
// import trkAdwords from 'kodyl-js/tracking/transport/adwords';
// import trkBing from 'kodyl-js/tracking/transport/bing';
import trkFacebook from 'kodyl-js/tracking/transport/facebook';

// import { CLIENT_CONFIG_KEY } from 'shared/constants';
// import {
//   MAX_AGE as COOKIE_MAX_AGE,
//   key as COOKIE_KEY,
//   options as COOKIE_OPTS
// } from 'shared/cookie';
//
// export const uuid = clientUUID({
//   ...COOKIE_OPTS,
//   maxAge: COOKIE_MAX_AGE / 1000,
//   key: COOKIE_KEY
// });
//
// function clientUUID({
//   key = '_ktu', // generic key; should be changed
//   maxAge = 365 * 24 * 60 * 60, // 1 year
//   path = '/',
//   domain,
//   secure
// }) {
//   const value = cookies.getItem(key) || uuidV4();
//   cookies.setItem(key, value, maxAge, path, domain, secure);
//   return value;
// }

export default function(config: { clicky: number, fbq: string }) {
  try {
    if (__DEV__ || window.location.hostname === 'localhost') {
      addTracking(
        'console',
        require('kodyl-js/tracking/transport/console').default()
      );
    } else {
      window.addEventListener(
        'CookieInformationConsentGiven',
        function(event) {
          // if (
          //   window.CookieInformation.getConsentGivenFor('cookie_cat_unclassified')
          // ) {
          // }
          // if (window.CookieInformation.getConsentGivenFor('cookie_cat_necessary')) {
          // }
          // if (
          //   window.CookieInformation.getConsentGivenFor('cookie_cat_functional')
          // ) {
          // }
          if (
            window.CookieInformation.getConsentGivenFor('cookie_cat_statistic')
          ) {
            // Legacy clicky for Boligninja
            // clickyInit({
            //   siteId: config.clicky,
            //   uid: {
            //     cookieKey: '_bntu'
            //   }
            // });
            addTracking(
              'ga',
              trkGA({
                trackingId: config.ga
              })
            );
          }
          if (
            window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')
          ) {
            addTracking(
              'facebook',
              trkFacebook({
                pixelId: config.fbq
              })
            );
          }
        },
        false
      );

      // const config = global[CLIENT_CONFIG_KEY];

      // addTracking(
      //   'adwords',
      //   trkAdwords({
      //     conversionId: config.adwords
      //   })
      // );

      // addTracking(
      //   'bing',
      //   trkBing({
      //     trackingId: config.bing
      //   })
      // );

      // addTracking(
      //   'clicky',
      //   trkClicky({
      //     siteId: config.clicky,
      //     custom: { visitor: { uuid } }
      //   })
      // );
    }
  } catch (err) {
    if (__DEV__) {
      console.error(err);
    }
  }
}
